import CountryPageTemplate from "../../components/country/CountryPageTemplate";
import { countryPages } from "../../data/countries";

function IrelandPage() {
  return <CountryPageTemplate country={countryPages.ireland} />;
}

export default IrelandPage;
